import createIcon from '../../createIcon';

/**
 * @component @name AssignmentInd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxNC44MkMxNC40IDIuODQgMTMuMyAyIDEyIDJDMTAuNyAyIDkuNiAyLjg0IDkuMTggNEg1QzMuOSA0IDMgNC45IDMgNlYyMEMzIDIxLjEgMy45IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xMiA0QzEyLjU1IDQgMTMgNC40NSAxMyA1QzEzIDUuNTUgMTIuNTUgNiAxMiA2QzExLjQ1IDYgMTEgNS41NSAxMSA1QzExIDQuNDUgMTEuNDUgNCAxMiA0Wk0xMiA4QzEzLjY2IDggMTUgOS4zNCAxNSAxMUMxNSAxMi42NiAxMy42NiAxNCAxMiAxNEMxMC4zNCAxNCA5IDEyLjY2IDkgMTFDOSA5LjM0IDEwLjM0IDggMTIgOFpNMTggMjBINlYxOC42QzYgMTYuNiAxMCAxNS41IDEyIDE1LjVDMTQgMTUuNSAxOCAxNi42IDE4IDE4LjZWMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AssignmentInd = createIcon('AssignmentInd', [
  [
    'path',
    {
      d: 'M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4ZM12 8C13.66 8 15 9.34 15 11C15 12.66 13.66 14 12 14C10.34 14 9 12.66 9 11C9 9.34 10.34 8 12 8ZM18 20H6V18.6C6 16.6 10 15.5 12 15.5C14 15.5 18 16.6 18 18.6V20Z',
      key: '16kf9p',
    },
  ],
]);

export default AssignmentInd;
